const HOW_CLASS   = 'product-how-it-works';
const HOW_DATA    = 'data-product-how-it-works';
const LIGHT_MOD   = `${HOW_CLASS}--light`;                   // модификатор для светлого фона
const ACTIVE_WRAP = `${HOW_CLASS}__wrap--active`;
const ACTIVE_NAV  = `${HOW_CLASS}__nav-item--active`;

/* -------------------------------------------------------------------------- */
/* 1. Инициализация блока                                                     */
/* -------------------------------------------------------------------------- */
document.querySelectorAll(`[${HOW_DATA}]`).forEach(initHowBlock);

function initHowBlock(root) {
    initTabs(root);
    initBannerLightness(root, HOW_CLASS, LIGHT_MOD); // <— автоцвет
}

/* -------------------------------------------------------------------------- */
/* 2. Переключение вкладок                                                    */
/* -------------------------------------------------------------------------- */
function initTabs(root) {
    const navItems = root.querySelectorAll(`[${HOW_DATA}-nav]`);
    const wraps    = root.querySelectorAll('[data-wrap]');

    navItems.forEach(item => {
        item.addEventListener('click', () => {
            const id = item.getAttribute(`${HOW_DATA}-nav`);
            navItems.forEach(el => el.classList.remove(ACTIVE_NAV));
            wraps.forEach(el => el.classList.remove(ACTIVE_WRAP));

            item.classList.add(ACTIVE_NAV);
            root.querySelector(`[data-wrap="${id}"]`)?.classList.add(ACTIVE_WRAP);
        });
    });
}

/* -------------------------------------------------------------------------- */
/* 3. Определяем «светлый» фон и добавляем класс                              */
/* -------------------------------------------------------------------------- */
function initBannerLightness(root, classPrefix, lightMod) {
    const container = root.querySelector(`.${classPrefix}__container`);
    if (!container) return;

    const bg   = getBackground(container);
    const rgb  = toRgb(bg);
    if (!rgb) return;

    const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    if (brightness > 180) root.classList.add(lightMod);
}

/* ---------- helpers ---------- */
function getBackground(el) {
    const inline = el.style.background || '';
    const match  = inline.match(/#(?:[0-9a-f]{3}){1,2}/i);
    return (match?.[0]) || window.getComputedStyle(el).backgroundColor;
}

function toRgb(color) {
    if (color.startsWith('#')) {
        let hex = color.slice(1);
        if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
        const int = parseInt(hex, 16);
        return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255 };
    }
    if (color.startsWith('rgb')) {
        const v = color.match(/\d+/g)?.map(Number);
        return v && v.length >= 3 ? { r: v[0], g: v[1], b: v[2] } : null;
    }
    return null;
}
